import HtmlElement from '../../../Elements/HtmlElement';

/**
 * Exitintent
 */
const Exitintent = (() => {
	/**
	 * Selector
	 *
	 * @var { Object }
	 */
	const Selector = {
		EXIT_INTENT: '.cta-exit-intent'
	};

	/**
	 * Exitintent
	 *
	 * @class
	 * @augments HtmlElement
	 */
	class Exitintent extends HtmlElement {
		// Public

		/**
		 * Handles ready event
		 *
		 * @return void
		 */
		onReady() {
			super.onReady();
			this.wasVisible = false;
			this.uid = parseInt(this.$element.data('uid'));
			this.storageIdentifier = `ig_cta_exitintent_${this.uid}_opened`;
			this.canOpen = !localStorage.getItem(this.storageIdentifier) && !window.location.search.includes('deepl');

			$(document).on('mouseleave', (e) => {
				if (e.clientY < 0) {
					this.show();
				}
			});

			$(window).on('keydown', (e) => {
				if (e.key === 'Escape') {
					this.hide();
				}
			});

			this.$element.find('[data-hide]').on('click', () => {
				this.hide();
			});

			let touchStartY = 0;
			let touchEndY = 0;
			let touchStartTime = 0;
			let touchEndTime = 0;

			const minSwipeDistance = 50;
			const minSwipeSpeed = 0.6;

			$(document).on('touchstart', (e) => {
				touchStartY = e.originalEvent.touches[0].clientY;
				touchStartTime = new Date().getTime();
			});

			$(document).on('touchend', (e) => {
				touchEndY = e.originalEvent.changedTouches[0].clientY;
				touchEndTime = new Date().getTime();

				const swipeDistance = touchStartY - touchEndY;
				const swipeTime = touchEndTime - touchStartTime;
				const swipeSpeed = Math.abs(swipeDistance) / swipeTime;

				if (swipeDistance < 0 && Math.abs(swipeDistance) > minSwipeDistance && swipeSpeed > minSwipeSpeed) {
					this.show();
				}
			});
		}

		show() {
			if (this.wasVisible || !this.canOpen) {
				return;
			}

			this.$element.addClass('visible');
			this.wasVisible = true;
			localStorage.setItem(this.storageIdentifier, 'true');
		}

		hide() {
			this.$element.removeClass('visible');
		}
	}

	return Exitintent._getElements(Selector.EXIT_INTENT, Exitintent);
})();

export default Exitintent;
